<!--
 * @Author: cmchiu
 * @Date: 2023-04-12 09:15:46
 * @LastEditTime: 2023-05-10 12:29:27
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\components\NewsIA\newsIA.vue
 * 
-->
<template>
    <div class="news w-100">
        <h2 class="sub-title">產學新聞</h2>
        <div class="news__content d-flex flex-wrap justify-content-center">
            <div class="news__slider w-100 d-flex justify-content-center flex-wrap">
                <router-link
                    v-for="news in newsLs"
                    :key="news.sno"
                    :to="{ path: 'news/Post', query: { id: MenuID, sno: news.sno } }"
                    class="news__item"
                >
                    <div
                        class="news__img w-100"
                        style="background-repeat: no-repeat; /* background-size: contain */"
                        :style="
                            news.ItemImages && news.ItemImages.length > 0
                                ? `background-image: url(${news.ItemImages[0].location});`
                                : ''
                        "
                    ></div>
                    <div class="news__text">
                        <p class="news__date" v-text="news.UpdDate ? news.UpdDate.substr(0, 10) : 'N/A'"></p>
                        <h3 class="news__title" v-text="news.ItemTitle"></h3>
                        <p class="news__description" v-text="news.ItemSubTitle"></p>
                    </div>
                </router-link>
            </div>
            <ul class="news__pagination d-flex">
                <li
                    v-for="page in pages.totalPage"
                    :key="page"
                    class="news__pagination-item"
                    :class="pages.pageCurrent === page ? 'news__pagination-item--active' : ''"
                    @click="pageChange({ currentPage: page, pageSize: pages.pageSize })"
                ></li>
            </ul>
        </div>
        <div class="news__more w-100 d-flex justify-content-center">
            <button class="more-btn">
                <router-link :to="{ path: MorePath, query: { id: MenuID } }">更多新聞</router-link>
            </button>
        </div>
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import { getItemContent } from '@/api/common'
import { getPath } from '@/utils/menu'

export default {
    name: 'cNewsIA',

    data() {
        return {
            configs: {
                loading: false,
            },
            MenuID: '0500',
            newsLs: [],
            pages: {
                totalPage: 3, // 總頁數
                totalResult: 0, // 總筆數
                pageSize: 4, // 分頁大小
                pageCurrent: 1, // 目前頁次
            },
            MorePath: '',
        }
    },

    created() {
        const vm = this
        getPath(vm.MenuID).then(path => {
            vm.MorePath = '/' + path
        })
        vm.getMenuItemLs()
    },

    methods: {
        async getMenuItemLs(chgFilters) {
            const vm = this
            vm.configs.loading = true
            if (chgFilters) vm.pages.pageCurrent = 1 //當條件改變時, 將當前頁次改回第1頁
            let params = {
                MenuID: vm.MenuID,
                // ItemStatus: vm.filter.status,
                // Keyword: vm.filter.keyword,
                PageSize: vm.pages.pageSize,
                PageCurrent: vm.pages.pageCurrent,
            }
            await getItemContent(params)
                .then(res => {
                    // handle success
                    vm.newsLs = [] //res.Items
                    XEUtils.arrayEach(res.Items, item => {
                        item.ItemImages = JSON.parse(item.ItemImages)
                        XEUtils.arrayEach(item.ItemImages, data => {
                            data.location = encodeURI(data.location)
                        })
                        item.ItemFiles = JSON.parse(item.ItemFiles)
                        XEUtils.arrayEach(item.ItemFiles, data => {
                            data.location = encodeURI(data.location)
                        })
                        vm.newsLs.push(item)
                    })
                    let pages = vm.pages
                    pages.totalResult = res.TotalResult
                    const totalPage = Math.ceil(pages.totalResult / pages.pageSize)
                    pages.totalPage = totalPage > 3 ? 3 : totalPage
                    if (totalPage < pages.pageCurrent) {
                        pages.pageCurrent = 1
                    }
                })
                .catch(err => {
                    // handle error
                    vm.newsLs = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },

        pageChange({ currentPage, pageSize }) {
            let page = this.pages
            page.pageCurrent = currentPage
            page.pageSize = pageSize
            this.getMenuItemLs()
        },
    },
}
</script>

<style scoped lang="scss">
.news__pagination-item {
    cursor: pointer;
}
</style>
